import UserLayout from "../components/UserLayout";
import Register from "../components/Register";
const RegisterPage = () => {
    return (
        <UserLayout>
            <Register />
        </UserLayout>
    );
}

export default RegisterPage;